import styled, { css } from 'styled-components';
import { Div } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

export const AlignReviews = styled(Div)`
  text-align: ${props => props.textAlign};
`;
 
export const RatingValue = styled(Div)`
  color: ${colors.charcoal};
  display: inline;
  font-size: 50px;
  font-weight: 450;

  ${props =>
    props.inline
    && css`
      line-height: 1;
    `}
`;
 
export const RatingWrapper = styled.div`
  ${props =>
    props.inline
    && css`
      display: flex;
      align-items: flex-end;
    `}
`;
 
